// Mirrors _features/imports/state/slice.js's shape. Drops the old
// features/exportFeature/slice.js's `exports` (write-only, never read back -
// the page renders from the RTK Query hook's own return value),
// `isLoading`/`error` (both reducers exist but are confirmed by grep to
// never be dispatched anywhere), and `customColumns` (the old
// useExportFilters.js's own mount effect unconditionally overwrote both
// local and Redux copies back to defaults on every mount, so persisting it
// was already pointless - customColumns now lives only in local useState in
// hooks/useExportsFilters.js, same as every other migrated feature).
import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const DEFAULT_SORT = "-createdAt";

const initialState = {
  selectedFilters: {
    sort: DEFAULT_SORT,
  },
};

const exportFeatureSlice = createSlice({
  name: "exportFeature",
  initialState,
  reducers: {
    updateSelectedFilters: (state, action) => {
      state.selectedFilters = action.payload;
    },
    resetSelectedFilters: (state) => {
      state.selectedFilters = {
        sort: DEFAULT_SORT,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.exportFeature) {
        const persistedFilters = action.payload.exportFeature.selectedFilters;

        return {
          ...state,
          selectedFilters: {
            ...(persistedFilters && typeof persistedFilters === "object" ? persistedFilters : {}),
            sort: persistedFilters?.sort || DEFAULT_SORT,
          },
        };
      }
      return state;
    });
  },
});

export const { updateSelectedFilters, resetSelectedFilters } = exportFeatureSlice.actions;

export default exportFeatureSlice.reducer;
